import React, { useState, useEffect, useCallback } from 'react'
import './Partners.css'
import { useTranslation } from 'react-i18next';

const partnerData = [
  {
    mainImg: 'product-card-1.png',
    titleKey: 'partners.card1',
    subImgs: ['partener-product-1.png', 'partener-product-2.png', 'partener-product-3.png', 'partener-product-4.png']
  },
  {
    mainImg: 'product-card-2.png',
    titleKey: 'partners.card2',
    subImgs: ['partener-product-5.png', 'partener-product-6.png', 'partener-product-7.png', 'partener-product-8.png']
  },
  {
    mainImg: 'product-card-3.png',
    titleKey: 'partners.card3',
    subImgs: ['partener-product-9.png', 'partener-product-10.png', 'partener-product-11.png', 'partener-product-12.png']
  },
  {
    mainImg: 'product-card-4.png',
    titleKey: 'partners.card4',
    subImgs: ['partener-product-13.png', 'partener-product-14.png', 'partener-product-15.png', 'partener-product-16.png']
  },
  {
    mainImg: 'product-card-5.png',
    titleKey: 'partners.card5',
    subImgs: ['partener-product-17.png', 'partener-product-18.png', 'partener-product-19.png', 'partener-product-20.png']
  },
  {
    mainImg: 'product-card-6.png',
    titleKey: 'partners.card6',
    subImgs: ['partener-product-21.png', 'partener-product-22.png', 'partener-product-23.png', 'partener-product-24.png']
  }
];

const Partners = () => {
  const { t, i18n } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
  const [visibleCards, setVisibleCards] = useState(3);

  const updateVisibleCards = useCallback(() => {
    // Force 3 cards per row on larger screens, maybe 1 on very small if necessary
    // but the user is VERY insistent on 3 per row.
    if (window.innerWidth >= 992) {
      setVisibleCards(3);
    } else if (window.innerWidth >= 768) {
      setVisibleCards(3); // Keep 3 for tablets as well if they insist
    } else {
      setVisibleCards(1);
    }
  }, []);

  useEffect(() => {
    updateVisibleCards();
    window.addEventListener('resize', updateVisibleCards);
    return () => window.removeEventListener('resize', updateVisibleCards);
  }, [updateVisibleCards]);

  const totalPages = Math.ceil(partnerData.length / visibleCards);

  const next = useCallback(() => {
    setCurrentPage((prev) => (prev + 1) % totalPages);
  }, [totalPages]);

  const prev = useCallback(() => {
    setCurrentPage((prev) => (prev - 1 + totalPages) % totalPages);
  }, [totalPages]);

  useEffect(() => {
    const timer = setInterval(next, 7000); // Slower auto-play for paginated
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section id='partners'>
      <div className="container-fluid px-md-5 my-5 px-3">
        <div className="text-center">
            <h6 className='section-title'>{t('partners.title')}</h6>
            <h4 className='section-suptitle'>{t('partners.subtitle')}</h4>
            <p className='section-desc mx-auto mb-3'>{t('partners.desc')}</p>
        </div>

        <div className="partners-slider-container mt-4 position-relative">
          <div className="partners-slider-window overflow-hidden">
            <div 
              className="partners-slider-track d-flex"
              style={{
                transform: `translateX(${i18n.language === 'ar' ? '' : '-'}${currentPage * 100}%)`,
                transition: 'transform 0.5s ease-in-out'
              }}
            >
              {[...Array(totalPages)].map((_, pageIdx) => (
                <div key={pageIdx} className="d-flex" style={{ minWidth: '100%' }}>
                  {partnerData.slice(pageIdx * visibleCards, (pageIdx + 1) * visibleCards).map((partner, idx) => (
                    <div 
                      key={idx} 
                      className="partner-slide px-2"
                      style={{ width: `${100 / visibleCards}%` }}
                    >
                      <div className="card rounded-0 h-100 shadow-sm">
                        <img src={partner.mainImg} className='img-fluid' alt="card" />
                        <div className="card-body">
                          <h2 className='partner-card-title my-3'>{t(partner.titleKey)}</h2>
                          <div className="row">
                            {partner.subImgs.map((sub, sIdx) => (
                              <div key={sIdx} className="col-6">
                                <img src={sub} className='img-fluid rounded-4 mb-4' alt="card-product" />
                              </div>
                            ))}
                          </div>
                          <a href="#contact" className="btn-outline-main w-100 rounded-1 py-2 d-flex align-items-center justify-content-center text-decoration-none">
                            {t('nav.contact_us').toUpperCase()}
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>

          <button className="partners-nav-btn prev" onClick={prev}>
            {i18n.language === 'ar' ? '›' : '‹'}
          </button>
          <button className="partners-nav-btn next" onClick={next}>
            {i18n.language === 'ar' ? '‹' : '›'}
          </button>

          <div className="partners-dots">
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i}
                className={`partners-dot ${i === currentPage ? 'active' : ''}`}
                onClick={() => setCurrentPage(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default Partners
